import { AsyncPipe, NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'new-actions',
  templateUrl: './new-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, PopoverModule, TranslateModule, AsyncPipe, NgClass],
})
export class NewActionsComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); // expected data ["edit","active","inactive"] etc
  rowIndex: number = 0;

  readonly onAction = output<{
    action: string;
    columnData: any;
    rowIndex: number;
  }>();
  showOptions = false;

  executeAction(action: string, columnData: any, overlayElement: any) {
    overlayElement.hide();
    this.onAction.emit({
      action,
      columnData: columnData,
      rowIndex: this.rowIndex,
    });
  }

  isActive(columnData: any): boolean {
    return columnData.status.toUpperCase() == 'Active'.toUpperCase();
  }

  isStatusVoid(columnData: any): boolean {
    return columnData.status.toLowerCase() == 'void';
  }
}
